import API from 'types/api';
import APP from 'types/app';

const initialState = {};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case API.GET_VIDEO_INFO_SUCCESS:
    case API.GET_EPISODES_SUCCESS:
      if (payload && payload.entities && payload.entities.episode) {
        return { ...state, ...payload.entities.episode };
      }
      return state;

    case APP.SAVE_MOVIE_POSITION:
      const { movieId, percent, position } = payload;
      let episode;
      if (state[movieId]) {
        episode = state[movieId];
      } else {
        episode = {};
        state[movieId] = episode;
      }
      episode.watched_history = {
        percent,
        position,
      };
      return {
        ...state,
      };

    default:
      return state;
  }
};
